import React, { use, useEffect, useState } from 'react';
import "./NotFound.scss"

const NotFound = () => {

    return (
        <div className="not-found">
            <span>404</span>
        </div>
    );
};

export default NotFound;
